import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { clearPersistedLoginBeforeBootstrap } from './app/core/service/browser-tab-session-cleanup';
import { environment } from './environments/environment';

// Configure Monaco worker location to avoid worker fetch errors
const monacoBase = `assets/monaco/min/`;
(window as any).MonacoEnvironment = {
  baseUrl: monacoBase,
  getWorkerUrl: () => `${monacoBase}vs/base/worker/workerMain.js`
};

if (environment.production)
{
  enableProdMode();
}

// Clear stale localStorage login before Angular boots. Runs without appConfig because
// channels.user is only persisted when cacheTokenToLocalStorage is enabled. Full session
// teardown (WebSocket, permissions) runs later in APP_INITIALIZER via AuthenticationService.reset().
clearPersistedLoginBeforeBootstrap();

platformBrowser()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
